import { useEffect } from 'react';
import { Box } from '@mui/material';
import { ChatProvider } from '../../contexts/ChatContext';
import { useGameConfig } from '../../hooks/useGameConfig';
import { PanelContainer } from './PanelContainer';
import { initTestData } from '../../services/testDataGenerator';
import { AppBar } from '../layout/AppBar';
import type { ThemeMode } from '../../App';

interface ShipConsoleProps {
  playerId: string;
  onMenuClick: () => void;
  themeMode: ThemeMode;
  onThemeModeChange: (mode: ThemeMode) => void;
  onDebugToggle: () => void;
}

export function ShipConsole({
  playerId,
  onMenuClick,
  themeMode,
  onThemeModeChange,
  onDebugToggle
}: ShipConsoleProps) {
  const gameConfig = useGameConfig();

  // Initialize test data generation on startup
  useEffect(() => {
    initTestData(playerId);
  }, [playerId]);

  return (
    <ChatProvider playerId={playerId} mcpServers={gameConfig.mcpServers}>
      <Box
        className="app-container"
        sx={{
          backgroundColor: 'background.default',
        }}
      >
        <AppBar
          onMenuClick={onMenuClick}
          themeMode={themeMode}
          onThemeModeChange={onThemeModeChange}
          onDebugToggle={onDebugToggle}
        />
        <Box className="main-content">
          <PanelContainer playerId={playerId} />
        </Box>
      </Box>
    </ChatProvider>
  );
}
